/* eslint-disable camelcase */
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

// firebase init goes here
const config = {
  apiKey: 'AIzaSyC4IDmlCUj0VKs_ZNS6IEJV-erBGl1VYWM',
  authDomain: 'erudite-visitor-250300.firebaseapp.com',
  databaseURL: 'https://erudite-visitor-250300.firebaseio.com',
  projectId: 'erudite-visitor-250300',
  storageBucket: 'erudite-visitor-250300.appspot.com',
  messagingSenderId: '277386242878',
  appId: '1:277386242878:web:e5671ff18e0778f3'
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const dbDel = firebase.firestore.FieldValue.delete();

// firebase collections
const users = db.collection('users');
const ACTS_Traits = db.collection('ACTS_Traits');
const ACTS_Content = db.collection('ACTS_Content');
const newACTS_Traits = db.collection('newACTS_Traits');
const newACTS_Content = db.collection('newACTS_Content');
const ACTS_Characters = db.collection('ACTS_Characters');
const Samsara = db.collection('Samsara');

export { db, users, ACTS_Traits, ACTS_Content, ACTS_Characters, newACTS_Content, newACTS_Traits, Samsara, dbDel };
